/**
 * className should prefix with wispformPlugin
 */

function getClassNamePrefix() {
  return "wispformPlugin";
}

function createFormIframe(url) {
  var iFrameNode = document.createElement("iframe");
  iFrameNode.className = getClassNamePrefix() + "-iframe";
  iFrameNode.src = url;
  return iFrameNode;
}

function createBackgroundModal() {
  var backgroundNode = document.createElement("div");
  backgroundNode.className = getClassNamePrefix() + "-modal";
  return backgroundNode;
}

function createCloseButton() {
  var closeButtonNode = document.createElement("div");
  closeButtonNode.className = getClassNamePrefix() + "-closeButton";
  return closeButtonNode;
}

function createIframeContainer() {
  var iframeContainer = document.createElement("div");
  var style = iframeContainer.style;
  style.position = "relative";
  return iframeContainer;
}

function createMobileHalfsheet(url) {
  var mobileContainer = document.createElement("div");
  mobileContainer.className = getClassNamePrefix() + "-mobileHalfsheet";
  mobileContainer.innerHTML =
    "<div class='wispformPlugin-mobileHalfsheet-header'><div class='wispformPlugin-mobileHalfsheet-close'></div><iframe class='wispformPlugin-mobileHalfsheet-iframe' src=" +
    url +
    "/></div>";

  return mobileContainer;
}

function getCSSFile() {
  var head = document.getElementsByTagName("HEAD")[0];
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = getServerDomain() + "plugin/buttonPopup/style.css";
  head.appendChild(link);
}

function getFont() {
  var head = document.getElementsByTagName("HEAD")[0];
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href =
    "https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext";
  head.appendChild(link);
}

function getFormUrlFromTarget(targetElement) {
  var name = targetElement.getAttribute("data-name");
  var id = targetElement.getAttribute("data-id");
  return "https://" + name + ".wispform.com/" + id;
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function getServerDomain() {
  return getUrlParameter("env") === "dev"
    ? "http://localhost:3002/"
    : "https://dashboard.wispform.com/";
}

function openForm() {}

function removeBackground(background) {
  if (background && background.parentNode) {
    background.parentNode.removeChild(background);
  }
}

function chainableAppend(parent, child) {
  parent.appendChild(child);
  return parent;
}

function chainablePrepend(parent, child) {
  parent.prepend(child);
  return parent;
}

function getAnchorElements() {
  // Old pop up use Id
  // New pop up use class name
  return [
    document.getElementById(getClassNamePrefix() + "-buttonPopup"),
    ...Array.from(
      document.getElementsByClassName(getClassNamePrefix() + "-buttonPopup")
    )
  ].filter(function(e) {
    return e != null;
  });
}

function isMobile() {
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

function easeInOutTimingFunction(movement, duration, cb) {
  var start = 0,
    currentTime = 0,
    increment = 15;

  function easeInOutQuad(time, start, end, duration) {
    time /= duration / 2;
    if (time < 1) return (end / 2) * time * time + start;
    time--;
    return (-end / 2) * (time * (time - 2) - 1) + start;
  }

  var animateScroll = function() {
    currentTime += increment;
    var val = easeInOutQuad(currentTime, start, 1000, duration);
    movement(val);
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else {
      cb && cb();
    }
  };
  animateScroll();
}

function slideUp(element, cb) {
  easeInOutTimingFunction(
    function(value) {
      var transform = "translateY(" + (2000 - value * 2) + "px)";
      element.style.transform = transform;
    },
    400,
    cb
  );
}

function slideDownAndDestroy(element, cb) {
  easeInOutTimingFunction(
    function(value) {
      var transform = "translateY(" + value + "px)";
      element.style.transform = transform;
    },
    400,
    function() {
      element.parentNode.removeChild(element);
      cb && cb();
    }
  );
}

function scaleUp(element, cb) {
  easeInOutTimingFunction(
    function(value) {
      var transform =
        "scale(" + ((value + 300) / 1000 > 1 ? 1 : (value + 300) / 1000) + ")";
      element.style.transform = transform;
    },
    250,
    cb
  );
}

function scaleDownAndDestroy(element, cb) {
  easeInOutTimingFunction(
    function(value) {
      var transform = "scale(" + (1000 - value) / 1000 + ")";
      element.style.transform = transform;
    },
    250,
    function() {
      element.parentNode.removeChild(element);
      cb && cb();
    }
  );
}

function createDesktopView(backgroundModal, url) {
  var iframeContainer = createIframeContainer();
  var desktopFormIframe = createFormIframe(url);
  var closeButton = createCloseButton();
  var mebedFormDesktop = chainableAppend(
    chainableAppend(iframeContainer, desktopFormIframe),
    closeButton
  );
  closeButton.addEventListener("click", function() {
    scaleDownAndDestroy(mebedFormDesktop, function() {
      removeBackground(backgroundModal);
    });
  });
  mebedFormDesktop.style.transform = "scale(0)";
  return mebedFormDesktop;
}

function createMobileView(url) {
  var mobileHalfsheet = createMobileHalfsheet(url);
  chainableAppend(document.body, mobileHalfsheet);
  mobileHalfsheet.style.transform = "translateY(-2000px)";
  return mobileHalfsheet;
}

function isAlreadyLoaded() {
  try {
    if (window && window.wispformEmbedButtonScriptLoaded) {
      return true;
    } else {
      window.wispformEmbedButtonScriptLoaded = true;
      return false;
    }
  } catch (error) {
    return false;
  }
}

function executeWhendocumentIsReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

(function main() {
  if (isAlreadyLoaded()) {
    return;
  }

  getCSSFile();
  getFont();
  window.addEventListener("message", event => {
    if (event.data.focusOutEvent === true) {
      document.body && (document.body.scrollTop = 0);
    }
  });

  executeWhendocumentIsReady(function() {
    getAnchorElements().map(function(element) {
      element.addEventListener("click", function(element) {
        const buttonDiv = element.currentTarget;
        const url = getFormUrlFromTarget(buttonDiv);
        var backgroundModal = createBackgroundModal();
        if (isMobile()) {
          const mobileHalfsheet = createMobileView(url);
          chainablePrepend(document.body, backgroundModal);
          slideUp(mobileHalfsheet);
          document
            .getElementsByClassName("wispformPlugin-mobileHalfsheet-close")[0]
            .addEventListener("click", function() {
              slideDownAndDestroy(mobileHalfsheet, () =>
                removeBackground(backgroundModal)
              );
            });
        } else {
          // isDesktop
          chainablePrepend(document.body, backgroundModal);
          const mebedFormDesktop = createDesktopView(backgroundModal, url);
          chainableAppend(backgroundModal, mebedFormDesktop);
          scaleUp(mebedFormDesktop, null);
        }
      });
    });
  });
})();
